import type { MutationHookOptions } from "@apollo/client"
import { useMutation, gql } from "@apollo/client"
import type { Mutation, MutationUpdateEmploymentTemplateArgs } from "@oysterhr/schema"
import { EmploymentTemplateFragment } from "~/shared/fragments/EmploymentTemplateFragment"

const UpdateEmploymentHiringTemplateMutation = gql`
  mutation UpdateEmploymentHiringTemplate($input: UpdateEmploymentTemplateInput!) {
    updateEmploymentTemplate(input: $input) {
      errors
      employmentTemplate {
        ...EmploymentTemplateFragment
      }
    }
  }
  ${EmploymentTemplateFragment}
`

type UseUpdateEmploymentHiringTemplateOptions = MutationHookOptions<
  UseUpdateEmploymentHiringTemplateReturnType,
  MutationUpdateEmploymentTemplateArgs
>

export type UseUpdateEmploymentHiringTemplateReturnType = {
  updateEmploymentTemplate: Mutation["updateEmploymentTemplate"]
}

type Options = UseUpdateEmploymentHiringTemplateOptions

export const useUpdateEmploymentHiringTemplate = (options?: Options) => {
  return useMutation<
    UseUpdateEmploymentHiringTemplateReturnType,
    MutationUpdateEmploymentTemplateArgs
  >(UpdateEmploymentHiringTemplateMutation, options)
}
